import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import {
  DieselRingColors,
  DieselRingSizes,
  DieselRingType,
  DieselRingVariantType,
} from './enums';
import { deepExpandStoreAliases } from '../../storeAliasHelper';

// TODO: Replace 'XXXXX' with actual Shopify variant IDs from Shopify admin
// Get variant IDs for each: Color (CRYO, PHANTOM) × Size (5-14, OPEN) × Store (IN, AE, ROW, US, EU, GB)
// Total: 2 colors × 11 sizes × ~6-9 stores = ~198 variant IDs needed

export const productMap_diesel_ring_PROD: Partial<
  Record<
    DieselRingColors,
    Partial<
      Record<DieselRingSizes, Record<DieselRingType, DieselRingVariantType>>
    >
  >
> = {
  [DieselRingColors.CRYO]: {
    [DieselRingSizes.FIVE]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-CRYO-05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44308484030534',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351031402867',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735081615420',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430167154784',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820361691510',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820361691510',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308484030534:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.SIX]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-CRYO-06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44308484227142',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351031599475',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735081812028',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430167187552',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820361920886',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820361920886',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308484227142:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.SEVEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-CRYO-07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44308484423750',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351031796083',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735082008636',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430167220320',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820362150262',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820362150262',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308484423750:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.EIGHT]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-CRYO-08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44308484620358',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351031992691',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735082205244',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430167253088',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820362379638',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820362379638',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308484620358:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.NINE]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-CRYO-09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44308484816966',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351032189299',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735082401852',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430167285856',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820362609014',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820362609014',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308484816966:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.TEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-CRYO-10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44308485013574',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351032385907',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735082598460',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430167318624',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820362838390',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820362838390',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308485013574:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.ELEVEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-CRYO-11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44308485210182',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351032582515',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735082795068',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430167351392',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820363067766',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820363067766',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308485210182:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.TWELVE]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-CRYO-12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44308485406790',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351032779123',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735082991676',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430167384160',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820363297142',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820363297142',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308485406790:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.THIRTEEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-CRYO-13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44308485603398',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351032975731',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735083188284',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430167416928',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820363526518',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820363526518',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308485603398:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.FOURTEEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-CRYO-14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44308485800006',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351033172339',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735083384892',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430167449696',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820363755894',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820363755894',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308485800006:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.OPEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-CRYO-OPEN',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44308495433798',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351033368947',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735083745340',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430167482464',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820363985270',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820363985270',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495433798:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
  },
  [DieselRingColors.PHANTOM]: {
    [DieselRingSizes.FIVE]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-PHANTOM-05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44350609227846',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351034515827',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735081680956',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430169677920',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820388921718',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820388921718',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495466566:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.SIX]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-PHANTOM-06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44350609260614',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351034548595',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735081877564',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430169710688',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820388954486',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820388954486',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495499334:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.SEVEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-PHANTOM-07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44350609293382',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351034581363',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735082074172',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430169743456',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820388987254',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820388987254',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495532102:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.EIGHT]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-PHANTOM-08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44350609326150',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351034614131',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735082270780',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430169776224',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820389020022',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820389020022',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495564870:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.NINE]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-PHANTOM-09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44350609358918',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351034646899',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735082467388',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430169808992',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820389052790',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820389052790',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495597638:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.TEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-PHANTOM-10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44350609391686',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351034679667',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735082663996',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430169841760',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820389085558',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820389085558',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495630406:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.ELEVEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-PHANTOM-11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44350609424454',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351034712435',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735082860604',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430169874528',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820389118326',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820389118326',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495663174:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.TWELVE]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-PHANTOM-12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44350609457222',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351034745203',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735083057212',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430169907296',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820389151094',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820389151094',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495695942:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.THIRTEEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-PHANTOM-13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44350609489990',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351034777971',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735083253820',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430169940064',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820389183862',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820389183862',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495728710:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.FOURTEEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-PHANTOM-14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44350609522758',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351034810739',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735083450428',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430169972832',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820389216630',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820389216630',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495761478:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
    [DieselRingSizes.OPEN]: {
      [DieselRingType.NOT_ENGRAVED]: {
        SKU: 'DIESEL-PHANTOM-OPEN',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/44350609555526',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62351034843507',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/43735083778108',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/42430170005600',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56820389249398',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56820389249398',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/44308495794246:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/XXXXX:1',
        },
        misc: {},
      },
    },
  },
};

// Expand store aliases (EU, GB, CA, AU, SA, MX, ZA inherit from US/ROW)
export const productMap_diesel_ring_PROD_expanded = deepExpandStoreAliases(
  productMap_diesel_ring_PROD,
);
